﻿import { ValgStateActionTypes, ValgState, TOGGLE_FORELDREANSVAR, TOGGLE_VILKAR, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    aFamiliesituasjon: undefined,
    bSivilstatus: undefined,
    bEnForelder: undefined,
    cSosken: undefined,
    visForeldreansvar: false,
    visVilkar: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aFamiliesituasjon) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_FORELDREANSVAR: {
                return {
                    ...state,
                    visForeldreansvar: !state.visForeldreansvar,
                };
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            default:
                return state;
        }
    }
}
